import React from 'react';
import classNames from 'classnames';
import styles from './index.less';

interface NavLabelProps {
  children: React.ReactNode;
  className?: string;
  strong?: boolean;
  size?: 'small' | 'medium' | 'large';
  noPadding?: boolean;
}

const NavLabel: React.FC<NavLabelProps> = ({
  children,
  className,
  strong,
  size,
  noPadding,
}) => {
  return (
    <div
      className={classNames(styles.navLabel, className, {
        [styles.strong]: strong,
        [styles.large]: size === 'large',
        [styles.small]: size === 'small',
        [styles.noPadding]: noPadding,
      })}
    >
      {children}
    </div>
  );
};

export default NavLabel;
